import CustomerAdditionalDocumentType from "../../domain/Registerv2/CustomerAdditionalDocumentType";
import UserSessionService from "../UserSessionService";
import BasicAuthGenerator from "../../utils/BasicAuthGenerator";
import RawWsService from "../RawWsService";

const ENDPOINT_BASE = "/utility/inbound-limit-increase-document-type";

export default class AdditionalDocumentTypeService {

    static retrieveByPurpose(purpose) {

        let endpoint = ENDPOINT_BASE + "?document-purpose=" + purpose;

        let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();

        let headers = {
            "Authorization": BasicAuthGenerator.create(registrationHeaders["registering-partner-username"], registrationHeaders["registering-partner-password"]),
            'registering-partner-id': registrationHeaders["registering-partner-id"],
            'registering-channel-id': registrationHeaders["registering-channel-id"]
        };

        return RawWsService.getWithHeaders(endpoint, {}, 200, headers).then(
            response => {
                let newArray = [];
                response.body.forEach(documentType => {
                    newArray.push(new CustomerAdditionalDocumentType(documentType));
                });
                return newArray;
            },
            response => {
                return response;
            });
    }
}